export enum CommunicationsPanelAvailabilityEnd {
  Indefinitely = 1,
  UntilWorkflowCompletion = 2,
}